<div class="mobile-apps-container" *ngLet="onLangChange$ | async">
  <div class="content-container">
    <div class="title-wrapper mb32">
      <svg [icon]="icons.Apps" class="svg32 mr12 dark-gray-color" />
      <h2 class="overline-link mobile-apps-title dark-gray-color">{{ 'MAIN.POPULAR_APPLICATIONS' | translate }}</h2>
      <button class="btn-empty show-all" (click)="toggleMobileMenu()">
        <span class="overline-link primary-color">все</span>
      </button>
    </div>

    <ng-container *ngIf="popularApps?.length; else loading">
      <ng-container [ngSwitch]="breakPointObserve$ | async">
        <ng-container *ngSwitchDefault>
          <div class="carousel-wrapper">
            <div class="prev-page button-page" (selectstart)="$event.preventDefault()"  (mousedown)="$event.preventDefault()" (click)="carousel.prev()">
              <svg [icon]="icons.PrevPageCarousel" class="svg32"></svg>
            </div>
            <app-carousel #carousel [autoplay]="false">
              <ng-container *ngFor="let apps of appsSlides$ | async; let i = index">
                <ng-container *carouselItem>
                  <div class="mobile-apps-card-wrapper">
                    <ng-container *ngTemplateOutlet="appCards; context: { cards: apps }"></ng-container>
                  </div>
                </ng-container>
              </ng-container>
            </app-carousel>
            <div class="next-page button-page"  (selectstart)="$event.preventDefault()"  (mousedown)="$event.preventDefault()" (click)="carousel.next()">
              <svg [icon]="icons.NextPageCarousel" class="svg32"></svg>
            </div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="948">
          <div class="mobile-card-scroller">
            <div class="cards-wrapper">
              <ng-container *ngTemplateOutlet="appCards; context: { cards: popularApps }"></ng-container>
            </div>
            <div class="scroll-hider"></div>
          </div>
        </ng-container>

        <ng-container *ngSwitchCase="400">
          <div class="cards-list">
            <ng-container *ngTemplateOutlet="appCards; context: { cards: popularApps?.slice(0, 3) }"></ng-container>
          </div>
          <ng-container *ngIf="isMobileMenuOpen">
            <div class="mobile-menu mobile-bottom-show-up">
              <div class="title-wrapper mb24">
                <svg [icon]="icons.Apps" class="svg32 mr12 dark-gray-color" />
                <h2 class="overline-link mobile-apps-title dark-gray-color">{{ 'MAIN.POPULAR_APPLICATIONS' | translate }}</h2>
                <button class="btn-empty show-all" (click)="toggleMobileMenu()">
                  <svg [icon]="icons.Close" class="svg24 dark-gray-color" />
                </button>
              </div>
              <div class="cards-list">
                <ng-container *ngTemplateOutlet="appCards; context: { cards: popularApps }"></ng-container>
              </div>
            </div>
          </ng-container>
        </ng-container>
      </ng-container>
    </ng-container>
  </div>
</div>

<ng-template #appCards let-cards="cards">
  <app-mobile-apps-card
    *ngFor="let app of cards"
    [mobileApp]="app"
    class="app-card"
  ></app-mobile-apps-card>
</ng-template>
<ng-template #loading>
  <div class="loader-wrapper">
    <app-loader class="loader"></app-loader>
  </div>
</ng-template>
